import type { CSSProperties } from "react";
import type { TColorWithWeights, TRadius } from "../scss";

export interface IColorable {
  color?: TColorWithWeights | string;
  bgColor?: TColorWithWeights;
}

const sizeProperties = [
  "width",
  "height",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight"
] as const;

type TSizeProperty = (typeof sizeProperties)[number];
export interface ISizable extends Pick<CSSProperties, TSizeProperty> {}

export function getSizes(obj: ISizable) {
  return Object.entries(obj).reduce((o, [key, value]) => {
    if (sizeProperties.includes(key as TSizeProperty))
      o[key as TSizeProperty] = cssUnit(value as string | number);
    return o;
  }, {} as ISizable);
}

export interface IBorderable {
  borderColor?: TColorWithWeights | string;
  borderThickness?: number | string;
  borderType?: string;
  borderRadius?: TRadius | string;
}

export function cssUnit(n: string | number): string {
  if (typeof n === "number" || /^\d+$/.test(n)) {
    return `${n}px`;
  }
  return n;
}
